import "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import React, { useState } from "react";

const CustomDatePicker = (props) => {
  const [date, setDate] = useState(null);
  const dateFormat = props.format || "MM/dd/yyyy";

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        format={dateFormat}
        clearable
        value={date}
        onChange={(event) => {
          setDate(event);
          props.onFilterChanged(props.columnDef.tableData.id, event);
        }}
      />
    </MuiPickersUtilsProvider>
  );
};
export default CustomDatePicker;
